/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Catalog from "../pages/sales/catalog/catalog";
import Product from "../pages/sales/product/product";
import Header from "../component/header/header";
import Footer from "../component/footer/footer";
import Cart from "../pages/sales/cart/cart";
import Checkout from "../pages/sales/checkout/checkout";
// import Orders from "../pages/sales/orders/orders"
// import Order from '../pages/sales/order/order';
// import Subscriptions from '../pages/sales/subscriptions/subsciptions';
import ErrorMsg from "../component/ErrorMsg";
// Imported from pmui
// import CreateProvider from '../pages/pm/provider/provider'
// import CreatePackage from '../pages/pm/packagedSolution/createPackage'
// import PackagedSolutionList from '../pages/pm/packagedSolutionList/packagedSolutionList'
// import CreateSpecialPrice from '../pages/pm/createPackage/createSpecialPrice/createSpecialPrice'
import { connect } from "react-redux";
import ManageCustomers from "../pages/sales/manageCustomers/manageCustomers";
import SDK from "../pages/api/sdk/sdk";
import ApiPortal from "../pages/api/apiPortal/apiPortal";
import Registration from "../pages/api/registration/registration";
import ApiRef from "../pages/api/apiRef/apiRef";
import ApiReadOnly from "../pages/api/apiReadOnly/apiReadOnly";
import InternalAPI from "../pages/api/internalAPI/internalApi";
// import ProviderProfile from '../pages/pm/provider/providerProfile';
// import ProviderContracts from '../pages/pm/provider/providerContracts';
// import ViewContract from '../pages/pm/provider/viewContract';
// import BillingHistory from '../pages/sales/reports/billing/billingHistory';
// import Settlement from '../pages/sales/reports/settlement/settlement';
// import SolutionsContracts from '../pages/pm/provider/solutionContracts';
// import ViewPackage from '../pages/pm/viewPackage/viewPackage';
// import ComponentProduct from '../pages/pm/component/componentProduct';
// import Activation from '../pages/sales/activation/activation';
// import CustomerProfile from '../pages/pm/customer/profile';
// import Stats from '../pages/sales/stats/stats';
// import OrderReport from '../pages/sales/reports/order/orderReport';
// import Billing from '../pages/sales/reports/billing/billing';

// From Kore
// import AssetOwnershipReport from '../pages/sales/reports/asset/assetOwnershipReport';
// import ReturnAndExchange from '../pages/sales/order/returnAndExchange';
// import InventoryReport from '../pages/sales/reports/inventory/inventoryReport';
// import InventoryReceiveReport from '../pages/sales/reports/inventory/inventoryReceiveReport';
// import WorkOrderReport from '../pages/sales/reports/order/workOrderReport';
// import PaymentReport from '../pages/sales/reports/payment/paymentReport';
// import GenericReports from '../pages/sales/genericReports/reports';

// Admin routes
// import Admin from '../pages/admin/admin';
// import manageSalesChannels from '../pages/admin/manageSalesChannels';
// import manageSolutionProviders from '../pages/admin/manageSolutionProviders';
// import UpdatePackage from '../pages/pm/packagedSolution/createPackage'
// import manageServiceProviders from '../pages/admin/manageServiceProviders';

// logout route
import LogOut from "./logout";
import catalog from "../pages/sales/catalog/catalog";

// import the constant routes
import RoutesConstant from "../helper/routeConstants";
import PartSearch from "../pages/sales/reports/order/partSearch";
import SignUp from "./signUp";
import StatOrders from "../pages/sales/stats/orders";
import VerifyQuote from "../pages/sales/checkout/verifyQuote/verifyQuote";
import Quotes from "../pages/sales/quotes/quotes";
import Quote from "../pages/sales/quote/quote";
import AddonsManagement from "../pages/sales/addonsManagement/addonsManagement";
import DashboardReports from "../pages/sales/reports/dashboard/dashboardReports";
import IFRSReport from "../pages/sales/reports/ifrsReport/ifrsReport";
import Addons from "../pages/sales/addonsManagement/addons";

const AuthRoute = (props) => {
  // Creating routes list on the behalf on user permissions
  let vRoute = [];

  const addQuoteAndVerifyRoutes = () => {
    if (vRoute.some((r) => r.path === "/quote/:id")) {
      return;
    }
    vRoute.push({ path: "/quote", comp: Cart, exact: false });
    vRoute.push({ path: "/quote/:id", comp: VerifyQuote, exact: false });
    vRoute.push({ path: "/verifyQuote", comp: VerifyQuote, exact: false });
  };

  for (let [route, component] of RoutesConstant.routes.entries()) {
    if (props.menuPaths.includes(route)) {
      vRoute.push({ path: route, comp: component, exact: false });
      if (route === "/stats") {
        vRoute.push({
          path: "/stats/orderReport",
          comp: StatOrders,
          exact: false,
        });
      }
      if (route === "/cart") {
        // vRoute.push({ path: "/quote", comp: Cart, exact: false });
        // vRoute.push({ path: "/quote/:id", comp: VerifyQuote, exact: false });
        // vRoute.push({ path: "/verifyQuote", comp: VerifyQuote, exact: false });
        addQuoteAndVerifyRoutes();
      }
      if (route === "/orders") {
        if (props.quoteEnabled) {
          vRoute.push({ path: "/quotes", comp: Quotes, exact: false });
        }
      }
      if (route === "/newOrder") {
        vRoute.push({ path: "/changeOrder", comp: Catalog, exact: false });
        vRoute.push({ path: "/changeOrder/:id", comp: Product, exact: false });
      }
    }
    if (route === "/productOfferingRules" || route === "/receivingRules") {
      vRoute.push({ path: route, comp: component, exact: false });
    }
    // if (route === '/dashboard') {
    // 	vRoute.push({ path: '/dashboard', comp: DashboardReports, exact: false })
    // }
    if (route === "/ifrsReport") {
      vRoute.push({ path: "/ifrsReport", comp: IFRSReport, exact: false });
    }
  }

  if (
    props.menuPaths.includes("/orders") &&
    props.menuPaths.includes("/order/:orderId")
  ) {
    addQuoteAndVerifyRoutes();
  }

  // if (props.providerType === 'ADMIN_PROVIDER') {
  // 	vRoute.push({ path: '/dashboard', comp: Admin, exact: true })
  // 	vRoute.push({ path: '/providers/:providerType', comp: CreateProvider, exact: true })
  // 	if (props.isCbizAdmin) {
  // 		vRoute.push({ path: '/manageSalesChannels', comp: manageSalesChannels, exact: true })
  // 		vRoute.push({ path: '/manageSolutionProviders', comp: manageSolutionProviders, exact: true })
  // 		vRoute.push({ path: '/manageServiceProviders', comp: manageServiceProviders, exact: true })
  // 	}
  // } else if ((props.loggedInUserType !== "ECOMMERCE_CUSTOMER") && (props.providerType === 'SALES_CHNL_PROVIDER' || props.providerType === 'SOLUTION_PROVIDER' || props.providerType === 'SERVICE_PROVIDER')) {
  // 	vRoute.push({ path: '/profile', comp: ProviderProfile, exact: true })
  // 	vRoute.push({ path: '/contracts', comp: ProviderContracts, exact: true })
  // 	vRoute.push({ path: '/contract/:contractId', comp: ViewContract, exact: true })
  // 	vRoute.push({ path: '/contract/:id/:contractId', comp: ViewContract, exact: true })
  // 	vRoute.push({ path: '/:provider/contracts', comp: SolutionsContracts, exact: true })
  // 	vRoute.push({ path: '/:provider/contracts/:contractId', comp: ViewContract, exact: true })
  // 	if (props.privileges.VIEW_CATALOG || props.privileges.VIEW_ORDERS ||
  // 		props.privileges.CREATE_ORDERS || props.privileges.ADMIN_ORDERS ||
  // 		props.privileges.VIEW_SUBSCRIPTIONS || props.privileges.ADMIN_SUBSCRIPTIONS) {
  // 		vRoute.push({ path: '/product', comp: Catalog, exact: true })
  // 		vRoute.push({ path: '/product/:id', comp: Product, exact: true })
  // 		vRoute.push({ path: '/newOrder/:id', comp: Product, exact: true })
  // 		vRoute.push({ path: '/cart', comp: Cart, exact: true })
  // 		vRoute.push({ path: '/checkout', comp: Checkout, exact: false })
  //
  // 		//pratyush we should do the new way
  // 		// vRoute.push({ path: '/orders', comp: Orders, exact: true })
  // 		// vRoute.push({ path: '/newOrder', comp: Catalog, exact: true })
  //
  // 		vRoute.push({ path: '/activate/:id', comp: Activation, exact: true })
  // 		vRoute.push({ path: '/order/:orderId', comp: Order, exact: false })
  // 		vRoute.push({ path: '/subscriptions', comp: Subscriptions, exact: true })
  // 		// Screens not done
  // 		vRoute.push({ path: '/manageCustomers', comp: ManageCustomers, exact: true })
  // 		vRoute.push({ path: '/billingRecords', comp: BillingHistory, exact: true })
  // 		vRoute.push({ path: '/billing', comp: Billing, exact: true })
  // 		vRoute.push({ path: '/settlement', comp: Settlement, exact: true })
  // 		vRoute.push({ path: '/stats', comp: Stats, exact: false })
  // 		vRoute.push({ path: '/orderReport', comp: OrderReport, exact: false })
  //
  // 		vRoute.push({ path: '/inventoryReport', comp: InventoryReport, exact: true })
  // 		vRoute.push({ path: '/inventoryReceiptReport', comp: InventoryReceiveReport, exact: true })
  // 		vRoute.push({ path: '/paymentReport', comp: PaymentReport, exact: true })
  // 		vRoute.push({ path: '/workOrders', comp: WorkOrderReport, exact: true })
  // 		vRoute.push({ path: '/report/:reportName', comp: GenericReports, exact: false })
  //
  // 		vRoute.push({ path: '/asset', comp: AssetOwnershipReport, exact: true })
  // 		vRoute.push({ path: '/return/:id', comp: ReturnAndExchange, exact: true })
  // 	}
  // 	if (props.privileges.BUILD_SOLUTION) {
  // 		vRoute.push({ path: '/createPackage', comp: CreatePackage, exact: true })
  // 		vRoute.push({ path: '/updatePackage', comp: UpdatePackage, exact: true })
  // 		vRoute.push({ path: '/editPackage', comp: PackagedSolutionList, exact: true })
  // 		vRoute.push({ path: '/myOfferings', comp: PackagedSolutionList, exact: true })
  // 		vRoute.push({ path: '/availableOfferings', comp: PackagedSolutionList, exact: true })
  // 		vRoute.push({ path: '/createSpecialPrice', comp: CreateSpecialPrice, exact: true })
  // 		vRoute.push({ path: '/viewProduct/:id', comp: ViewPackage, exact: true })
  //
  // 		//for component create and edit
  // 		vRoute.push({ path: '/products', comp: ComponentProduct, exact: true })
  // 	}
  // } else if (props.loggedInUserType === "ECOMMERCE_CUSTOMER") {
  // 	vRoute.push({ path: '/product', comp: Catalog, exact: true })
  // 	vRoute.push({ path: '/product/:id', comp: Product, exact: true })
  // 	vRoute.push({ path: '/newOrder/:id', comp: Product, exact: true })
  // 	vRoute.push({ path: '/cart', comp: Cart, exact: true })
  // 	vRoute.push({ path: '/checkout', comp: Checkout, exact: false })
  //
  // 	//pratyush we should do the new way
  // 	// vRoute.push({ path: '/orders', comp: Orders, exact: true })
  // 	// vRoute.push({ path: '/newOrder', comp: Catalog, exact: true })
  //
  // 	vRoute.push({ path: '/order/:orderId', comp: Order, exact: false })
  //
  // 	vRoute.push({ path: '/myProfile', comp: CustomerProfile, exact: true })
  //
  // 	vRoute.push({ path: '/subscriptions', comp: Subscriptions, exact: true })
  //
  // 	vRoute.push({ path: '/manageCustomers', comp: ManageCustomers, exact: true })
  // 	vRoute.push({ path: '/billingRecords', comp: BillingHistory, exact: true })
  // 	vRoute.push({ path: '/billing', comp: Billing, exact: true })
  // 	vRoute.push({ path: '/activate/:id', comp: Activation, exact: true })
  // 	vRoute.push({ path: '/asset', comp: AssetOwnershipReport, exact: true })
  // 	vRoute.push({ path: '/return/:id', comp: ReturnAndExchange, exact: true })
  // }
  //
  // if (props.menuPaths.includes('/orders') ) {
  // 	vRoute.push({ path: '/orders', comp: Orders, exact: true })
  // }
  // if (props.menuPaths.includes('/newOrder') ) {
  // 	vRoute.push({ path: '/newOrder', comp: Catalog, exact: true })
  // }

  vRoute.push({ path: "/partSearch", comp: PartSearch, exact: true });
  // vRoute.push({ path: "/assets", comp: AddonsManagement, exact: true });
  vRoute.push({ path: "/assets", comp: Addons, exact: true });
  // var sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  var sideMenu = props.sideMenu;
  return (
    <React.Fragment>
      {/* Global authorised app header */}
      <Header />
      {/* Global error message component */}
      <div
        className={
          sideMenu
            ? props.isMenuDrawerOpen
              ? "right-panel right-panel-open"
              : "right-panel"
            : ""
        }
      >
        <ErrorMsg />
        {/* Set authorised app routes */}
        <Routes>
          {props.tenantId ? (
            <>
              {/* ROOT route */}
              <Route
                path="/"
                element={
                  props.providerType === "ADMIN_PROVIDER" ? (
                    <Navigate to="/dashboard" replace />
                  ) : props.providerType === "SALES_CHNL_PROVIDER" ||
                    props.providerType === "SOLUTION_PROVIDER" ||
                    props.providerType === "SERVICE_PROVIDER" ? (
                    props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType === "ECOMMERCE_ADMIN" ? (
                      <Navigate to="/newOrder" replace />
                    ) : props.providerType === "SOLUTION_PROVIDER" &&
                      props.securityGroupsList.includes("PARTNER_ADMIN") &&
                      props.menuPaths.includes("/dashboard") ? (
                      <Navigate to="/dashboard" replace />
                    ) : props.providerType === "SOLUTION_PROVIDER" &&
                      !props.securityGroupsList.includes("PARTNER_ADMIN") ? (
                      <Navigate to="/profile?type=task" replace />
                    ) : props.menuPaths.includes("/dashboard") ? (
                      <Navigate to="/dashboard" replace />
                    ) : (
                      <Navigate to="/profile" replace />
                    )
                  ) : (
                    <Navigate to="/newOrder" replace />
                  )
                }
              />

              {/* SOLUTIONS route */}
              <Route
                path="/solutions"
                element={
                  props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                    props.loggedInUserType === "ECOMMERCE_ADMIN" ? (
                    <Navigate to="/myProfile" replace />
                  ) : (
                    <Navigate to="/profile" replace />
                  )
                }
              />

              {/* DYNAMIC ROUTES */}
              {vRoute && vRoute.length > 0 ?
                vRoute.map((route, index) => (
                  <>
                    <Route
                      key={index}
                      path={route.path}
                      element={<route.comp key={route.path} />}
                    />
                    {/* {index === vRoute.length - 1 && (
                      <Route path="*" element={<Navigate to="/" replace />} />
                    )} */}
                  </>
                ))
                :
                <Route path="*" element={<Navigate to="/" replace />} />
              }

              {/* STATIC ROUTES */}
              <Route path="/api-portal" element={<ApiPortal />} />
              <Route path="/sdk" element={<SDK />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/api-ref" element={<ApiRef />} />
              <Route path="/api-read-only" element={<ApiReadOnly />} />
              <Route path="/internal-api" element={<InternalAPI />} />
              <Route path="/logout" element={<LogOut />} />
              {/* Catch-all redirect for unknown routes */}

              {/* OPTIONAL 404 HANDLER */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </>
          ) : (
            <>
              {props.publicBrowsing && (
                <>
                  <Route path="/solutions" element={<Catalog />} />
                  <Route path="/viewSolution/:id" element={<Product />} />
                  <Route path="/product/:id" element={<Product />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/signUp" element={<SignUp />} />
                  {/* <Route
                    path="*"
                    element={<Navigate to="/solutions" replace />}
                  /> */}
                </>
              )}
            </>
          )}
        </Routes>

        <Footer />
      </div>
    </React.Fragment>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    privileges: state.auth.privileges,
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    isCbizAdmin: state.auth.isCbizAdmin,
    menuPaths: state.auth.menuPaths,
    publicBrowsing: state.auth.publicBrowsing,
    isMenuDrawerOpen: state.auth.isMenuDrawerOpen,
    sideMenu: state.auth.sideMenu,
    quoteEnabled: state.auth.quoteEnabled,
    securityGroupsList: state.auth.securityGroupsList,
  };
};

export default connect(mapStateToProps)(AuthRoute);
